import { useEffect, useState, useCallback } from "react";
import { IAdvertisementImage } from "types/advertisement";
import { getImageFullPath } from "utils/image";

interface ImageSliderProps {
  images: IAdvertisementImage[];
  className?: string;
}

const ImageSlider = ({ images, className = "" }: ImageSliderProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const sortedImages = [...images].sort((a, b) => a.order - b.order);

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % sortedImages.length);
  }, [sortedImages.length]);

  useEffect(() => {
    if (sortedImages.length <= 1) return;

    const currentImage = sortedImages[currentIndex];
    const duration = currentImage?.duration || 5000;

    const timer = setTimeout(goToNext, duration);

    return () => clearTimeout(timer);
  }, [currentIndex, sortedImages, goToNext]);

  if (sortedImages.length === 0) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 ${className}`}>
        <span className="text-gray-400">No images</span>
      </div>
    );
  }

  const currentImage = sortedImages[currentIndex];

  return (
    <div className={`relative overflow-hidden flex items-center justify-center ${className}`}>
      <img
        key={currentImage.id}
        src={getImageFullPath(currentImage.imageKey)}
        alt={`Slide ${currentIndex + 1}`}
        className="w-full h-full object-contain transition-opacity duration-500"
      />
    </div>
  );
};

export default ImageSlider;
